import(/* webpackMode: "eager" */ "/github/workspace/nextjs-frontend/src/app/pdf-compressor/page.tsx");
